import React, { Suspense } from "react";
import { AuthProvider } from "./hooks/contexts/AuthContext";
import { RouterProvider } from "react-router-dom";
import { mobileRouter, webRouter } from "./routes/routes";
import { useMediaQuery } from "@mui/system";
import { Box, Typography } from "@mui/material";

function App() {
  const router = useMediaQuery('(max-width:900px)') ? mobileRouter : webRouter;
  return (
    <React.Fragment>
      <AuthProvider>
        <Suspense fallback={
          <Box
            sx={{
              height: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              gap: 2
            }}
          >
            <Box sx={{
              width: 40,
              height: 40,
              border: '3px solid #f3f3f3',
              borderTop: '3px solid #3498db',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
            }} />
            <Typography>Loading...</Typography>
          </Box>
        }>
          <RouterProvider router={router} />
        </Suspense>
      </AuthProvider>
    </React.Fragment>
  )
}

export default App;
